import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const usePhotographers = () =>
  store(
    useShallow((state) => ({
      data: state.data,
      _ids: state._ids,
      count: state.count,
      loading: state.loading,
      loadingSpinner: state.loadingSpinner,
      updatingIds: state.updatingIds,
      error: state.error,
      params: state.params,
      fetchPhotographers: state.fetchPhotographers,
      init: state.init,
      updateFilters: state.updateFilters,
      updatePagination: state.updatePagination,
      updateSort: state.updateSort,
      hasActiveFilters: state.hasActiveFilters,
      resetFilters: state.resetFilters,
      moderatePhotographer: state.moderatePhotographer,
      updateSpotlight: state.updateSpotlight,
      deletePhotographer: state.deletePhotographer,
      reset: state.reset,
    })),
  );
